import styled from 'styled-components';
import { Button, DrawerContent, Text } from '@grupoboticario/flora-react';

export const StyledDrawerContent = styled(DrawerContent)`
  width: 532px;
  padding: 16px 32px;

  header + div {
    padding: 24px;
    overflow: auto;
    height: 100%;
  }

  footer {
    border-top: 1px solid #ccc;
    padding-top: 24px;
  }
`;

export const FilterButton = styled(Button)`
  display: flex;
  width: 115px;

  span {
    display: flex;
    align-items: center;

    height: 24px;
    // margin-right: 12px;

    sup {
      align-self: flex-start;
      margin-left: 4px;
    }
  }

  svg {
    path {
      fill: ${({ theme }) => theme.colors.actionConvertionStatic};
    }
  }

  &:hover {
    svg {
      path {
        fill: white;
      }
    }
  }
`;

export const ClearFilterButton = styled(Text)`
  cursor: pointer;
  color: #384eca;
`;
